import { createFileRoute } from "@tanstack/react-router";

import { FormsScreen } from "#app/components/forms/forms-screen";
import { withFeatureFlag, withPermission } from "#app/components/permissions/require-permission";
import { FeatureFlagKey } from "#app/hooks/use-feature-flags";

export const Route = createFileRoute("/(app)/$workspace/settings/forms/")({
  component: withPermission("forms.manage", withFeatureFlag(FeatureFlagKey.FORMS, FormsScreen)),
});
